// This is the only exception where we import the Container from @mui/material:
// eslint-disable-next-line no-restricted-imports
import { Container as ContainerMUI } from '@mui/material';
import { useContext } from 'react';

import { colors } from '@/colors';
import { GlobalStateContext } from '@/contexts/GlobalStateContext';
import { IContainerProps } from '@/types/IContainerProps';
import { isDevelopment } from '@/utils/isDevelopment';

export const Container = ({
  useDimmer = false,
  disabled = false,
  children,
  debugColor,
  position,
  ...rest
}: IContainerProps) => {
  const { useDebugColor } = useContext(GlobalStateContext);
  const showDebugBorder = isDevelopment && useDebugColor && Boolean(debugColor);
  return (
    <ContainerMUI
      style={{
        pointerEvents: disabled ? 'none' : undefined,
        touchAction: disabled ? 'none' : undefined,
        position: position ?? 'relative',
      }}
      {...rest}
    >
      {children}
      {showDebugBorder && (
        <div
          style={{
            pointerEvents: 'none',
            touchAction: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderWidth: 4,
            borderColor: debugColor,
            borderStyle: 'solid',
          }}
        />
      )}
      {useDimmer && (
        <div
          className={'container-dimmer'}
          style={{
            pointerEvents: 'none',
            touchAction: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            opacity: disabled ? 0.5 : 0,
            backgroundColor: colors.grayMedium,
            transition: 'opacity 0.5s',
          }}
        />
      )}
    </ContainerMUI>
  );
};
